module.exports = __webpack_public_path__ + "img/accessory_pants_05.972a3cec.svg";